export const currentUser = {
  name: 'Budi Santoso',
  email: 'jamaah@umrohloka.com',
  avatar: 'BS',
  location: 'Jakarta Selatan',
  trustScore: 95,
  memberSince: 'Januari 2025',
  activePackage: 'Paket Gold Ramadan 2026',
};

export const packages = [
  {
    id: 1,
    name: 'Paket Gold Ramadan 2026',
    provider: 'PT. Al-Barokah Tour & Travel',
    price: 28500000,
    duration: '9 Hari 8 Malam',
    rating: 4.9,
    reviewCount: 142,
    trustScore: 98,
    sold: 142,
    badge: 'BEST SELLER',
    category: 'ramadan',
    image: 'https://images.unsplash.com/photo-1580418827493-f2b22c0a76cb?w=800&q=80',
    highlights: ['Hotel Bintang 5 Dekat Masjidil Haram', 'Visa Ekspres 3 Hari', 'Muthawwif 15 Tahun Pengalaman'],
    hotel: 'Pullman Zamzam Makkah',
    flight: 'Garuda Indonesia',
    departure: '15 Mar 2026',
    seats: 8,
  },
  {
    id: 2,
    name: 'Paket Silver Executive',
    provider: 'CV. Muhibbah Travel Indonesia',
    price: 22500000,
    duration: '12 Hari 11 Malam',
    rating: 4.8,
    reviewCount: 89,
    trustScore: 95,
    sold: 89,
    badge: 'POPULER',
    category: 'regular',
    image: 'https://images.unsplash.com/photo-1591604129939-f1efa4d9f7fa?w=800&q=80',
    highlights: ['Hotel Bintang 4 Area Aziziyah', 'Visa 5-7 Hari Kerja', 'Pembimbing Ibadah Tersertifikasi'],
    hotel: 'Royal Clock Tower Makkah',
    flight: 'Saudi Arabian Airlines',
    departure: '22 Mar 2026',
    seats: 15,
  },
  {
    id: 3,
    name: 'Paket Platinum VIP',
    provider: 'PT. Alhijaz Indowisata',
    price: 45500000,
    duration: '7 Hari 6 Malam',
    rating: 5.0,
    reviewCount: 67,
    trustScore: 99,
    sold: 67,
    badge: 'VIP',
    category: 'vip',
    image: 'https://images.pexels.com/photos/1537086/pexels-photo-1537086.jpeg?w=800&q=80',
    highlights: ["Hotel Bintang 5 View Ka'bah", 'Visa VIP 24 Jam', 'Private Muthawwif & Butler'],
    hotel: 'Fairmont Makkah Clock Royal Tower',
    flight: 'Garuda Indonesia - Business Class',
    departure: '10 Apr 2026',
    seats: 4,
  },
  {
    id: 4,
    name: 'Paket Hemat Reguler',
    provider: 'PT. Baitullah Jaya Tour',
    price: 18900000,
    duration: '14 Hari 13 Malam',
    rating: 4.6,
    reviewCount: 203,
    trustScore: 92,
    sold: 203,
    badge: 'HEMAT',
    category: 'regular',
    image: 'https://images.unsplash.com/photo-1515859005217-8a1f08870f59?w=800&q=80',
    highlights: ['Hotel Strategis Makkah & Madinah', 'Visa Reguler 10-14 Hari', 'Grup Jamaah Indonesia'],
    hotel: 'Makkah Grand Hotel',
    flight: 'Lion Air / Batik Air',
    departure: '1 Apr 2026',
    seats: 22,
  },
  {
    id: 5,
    name: 'Paket Keluarga Plus',
    provider: 'PT. Armina Prima Travel',
    price: 25800000,
    duration: '10 Hari 9 Malam',
    rating: 4.9,
    reviewCount: 118,
    trustScore: 97,
    sold: 118,
    badge: 'KELUARGA',
    category: 'keluarga',
    image: 'https://images.unsplash.com/photo-1584551246679-0daf3d275d0f?w=800&q=80',
    highlights: ['Kamar Keluarga (Family Room)', 'Program Anak Spesial', 'Dokter Pendamping'],
    hotel: 'InterContinental Dar Al Tawhid',
    flight: 'Garuda Indonesia',
    departure: '5 Mei 2026',
    seats: 12,
  },
  {
    id: 6,
    name: 'Paket Corporate Eksklusif',
    provider: 'PT. Saudaratours Indonesia',
    price: 52000000,
    duration: '8 Hari 7 Malam',
    rating: 5.0,
    reviewCount: 34,
    trustScore: 99,
    sold: 34,
    badge: 'EKSKLUSIF',
    category: 'vip',
    image: 'https://images.pexels.com/photos/26436662/pexels-photo-26436662.jpeg?auto=compress&cs=tinysrgb&w=800&q=80',
    highlights: ['Suite Hotel Premium Tower View', 'Akses Lounge VIP Bandara', 'Concierge 24/7'],
    hotel: 'Abraj Al-Bait Towers Makkah',
    flight: 'Business Class Charter',
    departure: 'Sesuai Permintaan',
    seats: 2,
  },
];

export const journeySteps = [
  {
    id: 1,
    label: 'Pendaftaran & DP',
    description: 'Pembayaran uang muka 20% berhasil dikonfirmasi',
    date: '30 Jan 2026',
    status: 'done',
    icon: 'check',
  },
  {
    id: 2,
    label: 'Pembayaran Lunas',
    description: 'Pelunasan total biaya paket selesai diproses',
    date: '15 Feb 2026',
    status: 'done',
    icon: 'check',
  },
  {
    id: 3,
    label: 'Visa Approved',
    description: 'Visa Umroh Kerajaan Arab Saudi telah disetujui',
    date: '28 Feb 2026',
    status: 'done',
    icon: 'check',
  },
  {
    id: 4,
    label: 'Tiket Issued',
    description: 'E-Tiket Garuda Indonesia GA-2847 telah diterbitkan',
    date: '1 Mar 2026',
    status: 'active',
    icon: 'plane',
  },
  {
    id: 5,
    label: 'Briefing Keberangkatan',
    description: 'Sesi pembekalan tata cara ibadah Umroh',
    date: '10 Mar 2026',
    status: 'pending',
    icon: 'users',
  },
  {
    id: 6,
    label: 'Berangkat ke Baitullah',
    description: 'InsyaAllah terbang menuju Tanah Suci',
    date: '15 Mar 2026',
    status: 'pending',
    icon: 'star',
  },
];

export const flightDetails = {
  airline: 'Garuda Indonesia',
  flightNumber: 'GA-2847',
  origin: { code: 'CGK', city: 'Jakarta', terminal: 'Terminal 3' },
  destination: { code: 'MED', city: 'Madinah', terminal: 'Terminal 1' },
  departure: { date: '15 Mar 2026', time: '23:50 WIB' },
  arrival: { date: '16 Mar 2026', time: '08:25 AST' },
  duration: '9j 35m',
  class: 'Economy Class',
  seat: '24C',
  bookingCode: 'UMROH-2847-BS',
  image: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=800&q=80',
};

export const escrowData = {
  totalAmount: 28500000,
  paketName: 'Paket Gold Ramadan 2026',
  provider: 'PT. Al-Barokah Tour & Travel',
  disbursedAmount: 5700000,
  lockedAmount: 22800000,
  escrowNumber: 'ESC-2026-001847',
  startDate: '30 Jan 2026',
  milestones: [
    {
      id: 1,
      label: 'DP 20%',
      description: 'Uang muka konfirmasi & reservasi pendaftaran',
      amount: 5700000,
      percentage: 20,
      status: 'released',
      releaseDate: '30 Jan 2026',
      note: 'Dicairkan saat pendaftaran dikonfirmasi',
    },
    {
      id: 2,
      label: 'Pembayaran Tiket & Visa 30%',
      description: 'Pembelian tiket penerbangan & pengurusan dokumen Visa',
      amount: 8550000,
      percentage: 30,
      status: 'locked',
      releaseDate: 'Est. 5 Mar 2026',
      note: 'Akan dicairkan setelah tiket penerbangan terbit',
    },
    {
      id: 3,
      label: 'Pelunasan 50%',
      description: 'Biaya hotel, muthawwif, transportasi & fasilitas',
      amount: 14250000,
      percentage: 50,
      status: 'locked',
      releaseDate: 'Est. 10 Mar 2026',
      note: 'Akan dicairkan H-5 sebelum keberangkatan',
    },
  ],
};

export const communityPosts = [
  {
    id: 1,
    user: { name: 'Siti Rahayu', avatar: 'SR', location: 'Jakarta Selatan', verified: true },
    content: 'Alhamdulillah, visa saya baru saja approved kemarin! Rasanya tidak sabar menanti keberangkatan ke Baitullah. Mohon doa dari seluruh keluarga besar jamaah UMROHLOKA.',
    likes: 234,
    comments: 45,
    time: '2 jam lalu',
    tags: ['#VisaApproved', '#BerangkatUmroh'],
    package: 'Paket Gold Ramadan 2026',
  },
  {
    id: 2,
    user: { name: 'Ahmad Fauzi', avatar: 'AF', location: 'Surabaya', verified: false },
    content: 'Tips hemat belanja perlengkapan umroh: beli koper H-30 karena biasanya ada early bird discount di Toko UMROHLOKA. Saya dapat diskon 15% untuk Delsey 26" kemarin!',
    likes: 189,
    comments: 67,
    time: '5 jam lalu',
    tags: ['#TipsUmroh', '#BeliHemat'],
    package: null,
  },
  {
    id: 3,
    user: { name: 'Dewi Anggraini', avatar: 'DA', location: 'Bandung', verified: true },
    content: 'Review jujur Paket Silver Executive: Sangat memuaskan! Hotel bintang 4 lokasinya tepat 300m dari Masjidil Haram. Muthawwifnya sabar dan informatif. Highly recommended untuk jamaah pemula!',
    likes: 312,
    comments: 89,
    time: '1 hari lalu',
    tags: ['#ReviewJujur', '#SilverExecutive'],
    package: 'Paket Silver Executive',
  },
  {
    id: 4,
    user: { name: 'Muhammad Rizky', avatar: 'MR', location: 'Medan', verified: false },
    content: 'Baru selesai briefing keberangkatan tadi malam. Tim UMROHLOKA sangat profesional dan persiapannya sangat detail. InsyaAllah berangkat 2 minggu lagi, mohon doa semuanya!',
    likes: 145,
    comments: 32,
    time: '2 hari lalu',
    tags: ['#Briefing', '#SiapBerangkat'],
    package: 'Paket Platinum VIP',
  },
  {
    id: 5,
    user: { name: 'Fatimah Zahra', avatar: 'FZ', location: 'Yogyakarta', verified: true },
    content: 'Smart Escrow UMROHLOKA benar-benar membuat saya tenang. Dana saya aman terkunci dan travel agent tidak bisa ambil sebelum waktunya. Fitur ini harusnya wajib di semua platform umroh!',
    likes: 421,
    comments: 103,
    time: '3 hari lalu',
    tags: ['#SmartEscrow', '#TenangBeribadah'],
    package: 'Paket Keluarga Plus',
  },
];

export const liveKajian = {
  title: "Fiqih Umroh: Tata Cara Thawaf & Sa'i yang Benar",
  speaker: 'Ustadz Dr. Abdullah Hadrami, Lc. MA',
  viewers: 1243,
  startTime: 'Sekarang - LIVE',
  thumbnail: 'https://images.pexels.com/photos/7129547/pexels-photo-7129547.jpeg?auto=compress&cs=tinysrgb&w=600',
  description: 'Panduan lengkap tata cara ibadah umroh sesuai sunnah Nabi SAW untuk jamaah Indonesia',
  nextSchedule: 'Sabtu, 8 Mar 2026 - 20:00 WIB',
};

export const products = [
  {
    id: 1,
    name: 'Koper Hardcase Delsey Turenne 26"',
    category: 'koper',
    price: 1850000,
    originalPrice: 2200000,
    rating: 4.8,
    reviews: 234,
    sold: 567,
    image: 'https://images.unsplash.com/photo-1565026057447-bc90a3dceb87?w=500&q=80',
    badge: 'BEST SELLER',
    description: 'Koper hardcase premium, TSA lock, material polycarbonate ringan & kuat',
  },
  {
    id: 2,
    name: 'Koper Samsonite Omni PC 28"',
    category: 'koper',
    price: 2450000,
    originalPrice: 3100000,
    rating: 4.9,
    reviews: 189,
    sold: 389,
    image: 'https://images.unsplash.com/photo-1670888664967-754807e90ca6?w=500&q=80',
    badge: 'PREMIUM',
    description: 'Koper premium 4-spinner wheels, expandable, ultralight design',
  },
  {
    id: 3,
    name: 'Baju Ihram Premium Towel Texture',
    category: 'pakaian',
    price: 185000,
    originalPrice: 250000,
    rating: 4.7,
    reviews: 456,
    sold: 1234,
    image: 'https://images.pexels.com/photos/26551045/pexels-photo-26551045.jpeg?auto=compress&cs=tinysrgb&w=500&q=80',
    badge: 'LARIS',
    description: 'Kain ihram berkualitas premium, nyaman dipakai seharian penuh',
  },
  {
    id: 4,
    name: 'Sandal Umroh Anti-Slip Premium',
    category: 'alas_kaki',
    price: 345000,
    originalPrice: 450000,
    rating: 4.6,
    reviews: 312,
    sold: 789,
    image: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=500&q=80',
    badge: 'COMFORT',
    description: 'Sandal khusus umroh, anti-slip, sol tebal untuk jarak jauh',
  },
  {
    id: 5,
    name: 'Tas Travel Selempang Anti-Theft',
    category: 'tas',
    price: 425000,
    originalPrice: 550000,
    rating: 4.8,
    reviews: 178,
    sold: 456,
    image: 'https://images.unsplash.com/photo-1636546113485-7658e3a2d067?w=500&q=80',
    badge: 'AMAN',
    description: 'Tas RFID-blocking, anti-maling, kapasitas A4 dengan USB port',
  },
  {
    id: 6,
    name: "Kitab Do'a Umroh Lengkap + QR Audio",
    category: 'perlengkapan',
    price: 85000,
    originalPrice: 120000,
    rating: 4.9,
    reviews: 678,
    sold: 2345,
    image: 'https://images.unsplash.com/photo-1542816417-0983c9c9ad53?w=500&q=80',
    badge: 'WAJIB',
    description: "Panduan do'a lengkap dengan QR code ke audio tilawah",
  },
  {
    id: 7,
    name: 'Sabuk Dokumen Anti-Maling',
    category: 'perlengkapan',
    price: 125000,
    originalPrice: 165000,
    rating: 4.7,
    reviews: 234,
    sold: 890,
    image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=500&q=80',
    badge: 'PRAKTIS',
    description: 'Dompet tersembunyi untuk menyimpan passport & dokumen penting',
  },
  {
    id: 8,
    name: 'Spray Wajah Air Zamzam 200ml',
    category: 'perawatan',
    price: 65000,
    originalPrice: 90000,
    rating: 4.8,
    reviews: 456,
    sold: 3456,
    image: 'https://images.pexels.com/photos/7033934/pexels-photo-7033934.jpeg?auto=compress&cs=tinysrgb&w=500&q=80',
    badge: 'SEGAR',
    description: 'Air zamzam asli dalam kemasan spray praktis bersertifikat halal',
  },
];

export const formatPrice = (price) => {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(price);
};
